module.exports = __webpack_public_path__ + "static/logo-eu-703b4f3f8dbda7793e74655a48c0eb2a.jpg";